module.exports = __webpack_public_path__ + "static/media/private.db3ce2af.jpg";